import { styled } from '@/styled-system/jsx';
import { Box } from '@zillow/constellation-10';

export const StyledMobileGrid = styled(Box, {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
    marginLeft: '400',
  },
  variants: {
    alwaysShowProgressMeterTitle: {
      true: {},
      false: {},
    },
    showDesktopViewBreakpoint: {
      md: {},
      xl: {},
      xxl: {},
    },
  },
  compoundVariants: [
    {
      alwaysShowProgressMeterTitle: false,
      showDesktopViewBreakpoint: 'md',
      css: {
        md: {
          display: 'none',
        },
      },
    },
    {
      alwaysShowProgressMeterTitle: false,
      showDesktopViewBreakpoint: 'xl',
      css: {
        xl: {
          display: 'none',
        },
      },
    },
    {
      alwaysShowProgressMeterTitle: false,
      showDesktopViewBreakpoint: 'xxl',
      css: {
        xxl: {
          display: 'none',
        },
      },
    },
  ],
});
